import { IsNotEmpty, Validate } from 'class-validator';
import { DisplayNameValidation } from 'src/core/customValidator/displayNameValidator';

import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { EntityModel } from 'src/core/services/data/models';
import { ContextService } from 'src/core/services/context.service';

export class DocumentTemplateCategoryListDataService extends DataService<typeof Model.General.Logic.ViewModels.DocumentTemplateCategoryItem, Model.General.Logic.ViewModels.DocumentTemplateCategoryItem, DocumentTemplateCategoryItem> {
    private id: number = 0;
    private getNextId(): number {
        this.id--;
        return this.id;
    }

    protected map(entity: Model.General.Logic.ViewModels.DocumentTemplateCategoryItem): DocumentTemplateCategoryItem {
        return new DocumentTemplateCategoryItemModel(entity);
    }

    static make(context?: ContextService): DocumentTemplateCategoryListDataService {
        return new DocumentTemplateCategoryListDataService(context, ctx => ctx.DocumentTemplateCategories);
    }

	add(defaultLanguage: string): Promise<DocumentTemplateCategoryItem> {
		const entity = new Model.General.Logic.ViewModels.DocumentTemplateCategoryItem();

		entity.id = this.getNextId();
		entity.type = Model.Core.Domain.Models.DocumentTemplateCategoryType.General;
		(entity as any).dynamicProperties = {
			displayName: { [defaultLanguage]: '' }
		};

		return this.create(() => entity);
	}
}

export class DocumentTemplateCategoryItemModel extends EntityModel<Model.General.Logic.ViewModels.DocumentTemplateCategoryItem, IDocumentTemplateCategorySummary> implements DocumentTemplateCategoryItem {
    @property<DocumentTemplateCategoryItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @IsNotEmpty({ message: 'Product is required' })
    @property<DocumentTemplateCategoryItemModel>(o => o.entity.type, (o, value) => o.entity.type = value)
    public type: DocumentTemplateCategoryType;

    @property<DocumentTemplateCategoryItemModel>((o) => {
        let usages = [];
        let value = o.entity.usages;
        for (let i = 1; value > 0; i <<= 1) {
            if (value & 1) {
                usages.push(i);
            }
            value >>= 1;
        }

        return usages;
    }, (o, value) => o.entity.usages = value.reduce((acc, curr) => acc | curr, 0))
    public usages: DocumentTemplateUsages[];

    @property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
    @Validate(DisplayNameValidation, ['en'])
    public dynamicProperties: { [prop: string]: any };
}



// WEBPACK FOOTER //
// ./src/app/general/document-template-categories/list/document-template-category-list.data.ts